export default __webpack_public_path__ + "static/media/angola.36946c94.png";